import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useTenantAccess } from '../../hooks/useTenantAccess'
import { FullPageSpinner } from './Spinner'

const REPORT_LABELS: Record<string, string> = {
  trial_balance: 'Trial Balance',
  profit_loss: 'Profit & Loss',
  balance_sheet: 'Balance Sheet',
  draft_financials: 'Financial Statements',
  cash_flow: 'Cash Flow',
  ar_aging: 'Aged Debtors',
  ap_aging: 'Aged Creditors',
  sales_day_book: 'Sales Day Book',
  customer_statement: 'Customer Statement',
  stock_valuation: 'Inventory Valuation',
  stock_movement: 'Stock Movement',
  vat_return: 'VAT Return',
}

interface ReportGateProps {
  code: string
  children: React.ReactNode
}

function Redirect({ code }: { code: string }) {
  const navigate = useNavigate()
  useEffect(() => {
    const label = REPORT_LABELS[code] ?? code
    toast.error(`${label} is not available on your current plan`)
    navigate('/reporting-hub', { replace: true })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export function ReportGate({ code, children }: ReportGateProps) {
  const { hasReport, isLoading } = useTenantAccess()

  if (isLoading) return <FullPageSpinner />
  if (!hasReport(code)) return <Redirect code={code} />
  return <>{children}</>
}
